import React from 'react';
import styles from './userFollowingPageStyles.scss';

import UserFollowingListContainer from 'buyside/components/container/UserAccount/UserFollowingListContainer';

import { useCurrentUserAccountFollowingQuery } from 'interfaces/graphql-typings';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const UserFollowingPage: React.FC<{}> = () => {
  const { loading, data } = useCurrentUserAccountFollowingQuery();

  if (loading || !data?.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;
  const { activeFollowedUsersCount } = data.currentUser;
  return (
    <>
      <div className={styles.pageTitle}>People You Follow</div>
      {activeFollowedUsersCount ? (
        <div>
          <UserFollowingListContainer />
        </div>
      ) : (
        <div className={styles.noContentMsg}>
          <p>You currently are not following anyone.</p>
        </div>
      )}
    </>
  );
};

export default UserFollowingPage;
